// Constant
import constants from "./constants/index";
import React, { useEffect, useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { useParams, useSearchParams } from "react-router-dom";
import Note from "../../assets/img/note.svg";
import NotePurple from "../../assets/img/note-purple.png";
import NoteOsenvelt from "../../assets/img/note-osenvelt.png";
import NoteStoboclo from "../../assets/img/note-stoboclo.png";
import NoteAvtozma from "../../assets/img/note-avtozma.png";
import NoteOmlyclo from "../../assets/img/note-omlyclo.svg";
import ExitTerms from "../popup/exitTerms";
import ExitPrivacy from "../popup/exitPrivacy";
import { getProductColor } from "../../utilities/productColor";
import { useLocation } from "react-router-dom";
import CelltrionCare from "../popup/celltrionCare";

const Eligibility = ({
  nextStep,
  handleCancel,
  register,
  setModalShow,
  isPatient,
  errors,
}) => {
  const [indication, setIndication] = useState(false);
  const [insuranceType, setInsuranceType] = useState(false);
  const [qountry, setQountry] = useState(false);
  const [ageeighteen, setAgeeighteen] = useState(false);
  const [patconsent, setPatconsent] = useState(false);
  const [textOptIn, setTextOptIn] = useState(false);
  const [qhippaconsent, setQhippaconsent] = useState(false);
  const [qreadterms, setReadTerms] = useState(false);
  const [role, setRole] = useState("");
  const [searchParams] = useSearchParams();
  const [exitPrivacy, setExitPrivacy] = useState(false);
  const [exitTerms, setExitTerms] = useState(false);
  const { category } = useParams();

  const location = useLocation();

  const [TsAndCsShowShow, setTsAndCsShow] = useState(false);

  const isZymfentra = category === "zymfentra";
  const isPaysign =
    category === "zymfentra" ||
    category === "steqeyma" ||
    category === "osenvelt" ||
    category === "stoboclo" ||
    category === "avtozma" ||
    category === "omlyclo" ||
    category === "adalimumab" ||
    category === "vegzelma";

  let noteIcon;

  switch (category) {
    case "zymfentra":
      noteIcon = NotePurple;
      break;
    case "osenvelt":
      noteIcon = NoteOsenvelt;
      break;
    case "stoboclo":
      noteIcon = NoteStoboclo;
      break;
    case "avtozma":
      noteIcon = NoteAvtozma;
      break;
    case "omlyclo":
      noteIcon = NoteOmlyclo;
      break;
    default:
      noteIcon = Note;
  }

  useEffect(() => {
    const passedRole = searchParams.get("role");
    if (passedRole) {
      setRole(passedRole);
    }
  }, [role, searchParams]);

  const defaultRole = role ?? "patient";
  const roleName = defaultRole.charAt(0).toUpperCase() + defaultRole.slice(1);

  const [insuranceTypeLabel, setInsuranceTypeLabel] = useState("");

  useEffect(() => {
    const value = category;
    if (isPatient) {
      switch (value) {
        case "zymfentra":
          setInsuranceTypeLabel(constants.INSURANCE_TYPE_STEQEYMA);
          break;
        case "yuflyma":
          setInsuranceTypeLabel(constants.INSURANCE_TYPE);
          break;
        case "steqeyma":
        case "osenvelt":
        case "stoboclo":
        case "avtozma":
        case "omlyclo":
        case "vegzelma":
        case "adalimumab":
          setInsuranceTypeLabel(constants.INSURANCE_TYPE_STEQEYMA);
          break;
        default:
          setInsuranceTypeLabel(constants.INSURANCE_TYPE);
          break;
      }
    } else {
      switch (value) {
        case "vegzelma":
          setInsuranceTypeLabel(constants.INSURANCE_TYPE_OTHER);
          break;
        case "adalimumab":
          setInsuranceTypeLabel(constants.INSURANCE_TYPE_STEQEYMA);
          break;
        default:
          setInsuranceTypeLabel(constants.INSURANCE_TYPE_OTHER);
          break;
      }
    }
  }, [category, isPatient]);

  const [residencyLabel, setResidencyLabel] = useState("");

  useEffect(() => {
    const value = category;
    if (isPatient) {
      switch (value) {
        case "yuflyma":
        case "adalimumab":
          setResidencyLabel(constants.PATIENT_RESIDENCY_PRESCRIBER);
          break;
        case "vegzelma":
          setResidencyLabel(constants.PATIENT_RESIDENCY_VEGZELMA);
          break;
        default:
          setResidencyLabel(constants.PATIENT_RESIDENCY);
          break;
      }
    } else {
      switch (value) {
        case "steqeyma":
        case "osenvelt":
        case "stoboclo":
        case "avtozma":
        case "omlyclo":
          setResidencyLabel(constants.PATIENT_RESIDENCY_STEQEYMA);
          break;
        case "adalimumab":
          setResidencyLabel(constants.PATIENT_RESIDENCY_PRESCRIBER);
          break;
        case "vegzelma":
          setResidencyLabel(constants.PATIENT_RESIDENCY_VEGZELMA);
          break;
        default:
          setResidencyLabel(constants.PATIENT_RESIDENCY_PRESCRIBER);
          break;
      }
    }
  }, [category, isPatient]);

  const [ageLabel, setAgeLabel] = useState("");

  useEffect(() => {
    const value = category;
    if (isPatient) {
      switch (value) {
        case "zymfentra":
        case "osenvelt":
        case "stoboclo":
        case "avtozma":
        case "omlyclo":
          setAgeLabel(constants.AGE_LABEL_PATIENT);
          break;
        case "vegzelma":
        case "adalimumab":
          setAgeLabel(constants.AGE_LABEL_OTHER);
          break;
        case "yuflyma":
          setAgeLabel(constants.AGE_LABEL_YUFLYMA_PATIENT);
          break;
        default:
          setAgeLabel(constants.AGE_LABEL);
          break;
      }
    } else {
      switch (value) {
        case "steqeyma":
        case "osenvelt":
        case "stoboclo":
        case "avtozma":
        case "omlyclo":
          setAgeLabel(constants.AGE_LABEL_PATIENT_STEQEYMA);
          break;
        case "yuflyma":
          setAgeLabel(constants.AGE_LABEL_YUFLYMA_OTHER);
          break;
        default:
          setAgeLabel(constants.AGE_LABEL_OTHER);
          break;
      }
    }
  }, [category, isPatient]);

  const [hippaRelationshipLabel, setHippaRelationshipLabel] = useState("");

  useEffect(() => {
    const value = category;

    if (isPatient) {
      switch (value) {
        case "yuflyma":
        case "adalimumab":
          setHippaRelationshipLabel(constants.HIPPA_RELATIONSHIP_LABEL_OTHER);
          break;
        case "zymfentra":
        case "steqeyma":
        case "osenvelt":
        case "stoboclo":
        case "avtozma":
        case "omlyclo":
        case "vegzelma":          
          setHippaRelationshipLabel(constants.HIPPA_RELATIONSHIP_LABEL_OTHER);
          break;
        default:
          setHippaRelationshipLabel(constants.HIPPA_RELATIONSHIP_LABEL);
          break;
      }
    } else {
      switch (value) {
        case "vegzelma":
          setHippaRelationshipLabel(constants.HIPPA_RELATIONSHIP_LABEL);
          break;
        case "yuflyma":
        case "adalimumab":
          setHippaRelationshipLabel(constants.HIPPA_RELATIONSHIP_LABEL_OTHER);
          break;
        default:
          setHippaRelationshipLabel(constants.HIPPA_RELATIONSHIP_LABEL_OTHER);
          break;
      }
    }
  }, [category, isPatient]);

  const IndicationHandler = (e) => {
    const value = e.target.value;
    if (
      (value === "8" && category === "vegzelma") ||
      (value === "9" &&
        (category === "yuflyma" || category === "adalimumab")) ||
      (value === "4" && category === "osenvelt") ||
      (value === "5" && category === "steqeyma") ||
      (value === "6" && category === "stoboclo") ||
      (value === "7" && category === "avtozma") ||
      (value === "5" && category === "omlyclo")
    ) {
      setModalShow(true);
      setIndication(true);
    } else {
      setIndication(false);
    }
  };
  const InsuranceTypeHandler = (e) => {
    const value = e.target.value;
    if (value !== "2") {
      setModalShow(true);
      setInsuranceType(true);
    } else {
      setInsuranceType(false);
    }
  };

  const QountryHandler = (e) => {
    const value = e.target.value;
    if (value === "N") {
      setModalShow(true);
      setQountry(true);
    } else {
      setQountry(false);
    }
  };
  const age18Handler = (e) => {
    const value = e.target.value;
    if (value === "N") {
      setModalShow(true);
      setAgeeighteen(true);
    } else {
      setAgeeighteen(false);
    }
  };

  const PATConsent = (e) => {
    const value = e.target.value;
    if (value === "N") {
      setModalShow(true);
      setPatconsent(true);
    } else {
      setPatconsent(false);
    }
  };

  const TextOptIn = (e) => {
    const value = e.target.value;
    if (value === "N") {
      setModalShow(true);
      setTextOptIn(true);
    } else {
      setTextOptIn(false);
    }
  };

  const QHIPPACONSENT = (e) => {
    const value = e.target.value;
    if (value === "N") {
      setModalShow(true);
      setQhippaconsent(true);
    } else {
      setQhippaconsent(false);
    }
  };

  const QREADTERMS = (e) => {
    const value = e.target.value;
    if (value === "N") {
      setModalShow(true);
      setReadTerms(true);
    } else {
      setReadTerms(false);
    }
  };

  const productColor = getProductColor(location.pathname);
  const productName = category;


  return (
    <>
      <ExitPrivacy
        show={exitPrivacy}
        externalLink="https://www.celltrionconnect.com/patient-privacy-policy"
        onHide={() => setExitPrivacy(false)}
      />

      <ExitTerms
        show={exitTerms}
        externalLink={"https://www.celltrionconnect.com/terms-of-use/"}
        onHide={() => setExitTerms(false)}
      />
      <div className="heads-icon">
        <div className="hi-icon">
          <img src={noteIcon} alt="notes" />
        </div>
        <div>
          {!isPaysign ? (
            <Card.Subtitle className="mb-2 text-muted">
              {roleName} Enrollment
            </Card.Subtitle>
          ) : null}
          <Card.Subtitle>
            <strong style={{ color: productColor }}>Step 1 of 2</strong>
          </Card.Subtitle>
          <Card.Title>
            {isPatient ? (
              <strong>Check Eligibility</strong>
            ) : (
              "Let's check your patient's eligibility"
            )}
          </Card.Title>
        </div>
      </div>
      <div>
        {category === "vegzelma" ? (
          <Form.Group className="mb-4" controlId="Q_INDICATION_VEGZELMA">
            <Form.Label>
              {" "}
              Has Vegzelma<sup className="reg">&reg;</sup> been prescribed for any one of the following conditions?
            </Form.Label>
            <Form.Select
              id="Q_INDICATION_VEGZELMA"
              name="Q_INDICATION_VEGZELMA"
              className={indication && "error"}
              {...register("Q_INDICATION_VEGZELMA", {
                onChange: (e) => {
                  IndicationHandler(e);
                },
              })}
            >
              <option selected disabled>
                Choose
              </option>
              <option value="1">
               Metastatic Colorectal Cancer (mCRC)
              </option>
              <option value="2">Non-Squamous Non-Small Cell Lung Cancer (NSCLC)</option>
              <option value="3">Recurrent Glioblastoma (GBM)</option>
              <option value="4">Metastatic Renal Cell Carcinoma (mRCC)</option>
              <option value="5">Persistent, Recurrent, or Metastatic Cervical Cancer</option>
              <option value="6">Epithelial Ovarian, Fallopian Tube, or Primary Peritoneal Cancer</option>
              <option value="8">Other</option>
            </Form.Select>
          </Form.Group>
        ) : category === "adalimumab" ? (
          <Form.Group className="mb-4" controlId="Q_INDICATION_ADALIMUMAB">
            <Form.Label>
              {" "}
              Has Adalimumab-aaty been prescribed for any one of the following
              conditions?
            </Form.Label>
            <Form.Select
              id="Q_INDICATION_ADALIMUMAB"
              name="Q_INDICATION_ADALIMUMAB"
              className={indication && "error"}
              {...register("Q_INDICATION_ADALIMUMAB", {
                onChange: (e) => {
                  IndicationHandler(e);
                },
              })}
            >
              <option selected disabled>
                Choose
              </option>
              <option value="1">Rheumatoid Arthritis</option>
              <option value="2">Juvenile Idiopathic Arthritis</option>
              <option value="3">Psoriatic Arthritis</option>
              <option value="4">Ankylosing Spondylitis</option>
              <option value="5">Crohn’s Disease</option>
              <option value="6">Ulcerative Colitis</option>
              <option value="7">Plaque Psoriasis</option>
              <option value="8">Hidradenitis Suppurativa</option>
              <option value="10">Uveitis</option>
              <option value="9">Other</option>
            </Form.Select>
          </Form.Group>
        ) : category === "steqeyma" ? (
          <Form.Group className="mb-4" controlId="Q_INDICATION_STEQEYMA">
            <Form.Label>
              Has STEQEYMA been prescribed for any of the following conditions?
            </Form.Label>
            <Form.Select
              id="Q_INDICATION_STEQEYMA"
              name="Q_INDICATION_STEQEYMA"
              className={indication && "error"}
              {...register("Q_INDICATION_STEQEYMA", {
                onChange: (e) => {
                  IndicationHandler(e);
                },
              })}
            >
              <option selected disabled>
                Choose
              </option>
              <option value="1">Moderate to severe psoriasis</option>
              <option value="2">Active psoriatic arthritis</option>
              <option value="3">
                Moderately to severely active Crohn’'s disease
              </option>
              <option value="4">
                Moderately to severely active ulcerative colitis
              </option>
              <option value="5">Other</option>
            </Form.Select>
          </Form.Group>
        ) : category === "osenvelt" ? (
          <Form.Group className="mb-4" controlId="Q_INDICATION_OSENVELT">
            <Form.Label>
              Has OSENVELT been prescribed for any of the following conditions?
            </Form.Label>
            <Form.Select
              id="Q_INDICATION_OSENVELT"
              name="Q_INDICATION_OSENVELT"
              className={indication && "error"}
              {...register("Q_INDICATION_OSENVELT", {
                onChange: (e) => {
                  IndicationHandler(e);
                },
              })}
            >
              <option selected disabled>
                Choose
              </option>
              <option value="1">
                Multiple myeloma and bone metastasis from solid tumors
              </option>
              <option value="2">Giant cell tumor of bone</option>
              <option value="3">Hypercalcemia of malignancy</option>
              <option value="4">Other</option>
            </Form.Select>
          </Form.Group>
        ) : category === "stoboclo" ? (
          <Form.Group className="mb-4" controlId="Q_INDICATION_STOBOCLO">
            <Form.Label>
              Has STOBOCLO been prescribed for any of the following conditions?
            </Form.Label>
            <Form.Select
              id="Q_INDICATION_STOBOCLO"
              name="Q_INDICATION_STOBOCLO"
              className={indication && "error"}
              {...register("Q_INDICATION_STOBOCLO", {
                onChange: (e) => {
                  IndicationHandler(e);
                },
              })}
            >
              <option selected disabled>
                Choose
              </option>
              <option value="1">
                Postmenopausal osteoporosis with high risk of fracture
              </option>
              <option value="2">
                Male osteoporosis with high risk of fracture
              </option>
              <option value="3">Glucocorticoid-induced osteoporosis</option>
              <option value="4">
                Prostate cancer treatment induced bone loss
              </option>
              <option value="5">
                Breast cancer treatment induced bone loss
              </option>
              <option value="6">Other</option>
            </Form.Select>
          </Form.Group>
        ) : category === "omlyclo" ? (
          <Form.Group className="mb-4" controlId="Q_INDICATION_OMLYCLO">
            <Form.Label>
              Has OMLYCLO been prescribed for any of the following conditions?
            </Form.Label>
            {/* Labels and order match the Figma comp (node 5015:2084). The
                numeric values are NOT specified by the comp - confirm the
                code-to-indication mapping against the PaySign enrollment spec
                before go-live. "Other" must stay last/highest: IndicationHandler
                keys the ineligibility modal off value "5". */}
            <Form.Select
              id="Q_INDICATION_OMLYCLO"
              name="Q_INDICATION_OMLYCLO"
              className={indication && "error"}
              {...register("Q_INDICATION_OMLYCLO", {
                onChange: (e) => {
                  IndicationHandler(e);
                },
              })}
            >
              <option selected disabled>
                Choose
              </option>
              <option value="1">
                Moderate to severe persistent asthma (6 years of age and older)
              </option>
              <option value="2">
                Chronic rhinosinusitis with nasal polyps (CRSwNP) (18 years of
                age and older)
              </option>
              <option value="3">Food Allergy (1 year of age and older)</option>
              <option value="4">
                Chronic spontaneous urticaria (CSU) (12 years of age and older)
              </option>
              <option value="5">Other</option>
            </Form.Select>
          </Form.Group>
        ) : category === "avtozma" ? (
          <Form.Group className="mb-4" controlId="Q_INDICATION_AVTOZMA">
            <Form.Label>
              Has AVTOZMA been prescribed for any of the following conditions?
            </Form.Label>
            <Form.Select
              id="Q_INDICATION_AVTOZMA"
              name="Q_INDICATION_AVTOZMA"
              className={indication && "error"}
              {...register("Q_INDICATION_AVTOZMA", {
                onChange: (e) => {
                  IndicationHandler(e);
                },
              })}
            >
              <option selected disabled>
                Choose
              </option>
              <option value="1">
                Rheumatoid Arthritis (18 years of age or older)
              </option>
              <option value="2">
                Giant Cell Arteritis (18 years of age or older)
              </option>
              <option value="3">
                Polyarticular Juvenile Idiopathic Arthritis (2&lt;18 years of
                age)
              </option>
              <option value="4">
                Systemic Juvenile Idiopathic Arthritis (2&lt;18 years of age)
              </option>
              <option value="5">
                Cytokine Release Syndrome (2 years of age or older)
              </option>
              <option value="6">COVID-19 (18 years of age or older)</option>
            </Form.Select>
          </Form.Group>
        ) : (
          <>
            <Form.Group className="mb-4" controlId="Q_INDICATION_ZYMFENTRA">
              <Form.Label>
                Has ZYMFENTRA been prescribed for any of the following
                conditions?
              </Form.Label>

              <Form.Select
                id="Q_INDICATION_ZYMFENTRA"
                name="Q_INDICATION_ZYMFENTRA"
                className={indication && "error"}
                {...register("Q_INDICATION_ZYMFENTRA", {
                  onChange: (e) => {
                    IndicationHandler(e);
                  },
                })}
              >
                <option selected disabled>
                  Choose
                </option>
                <option value="2">
                  Moderately to severely active ulcerative colitis following
                  treatment with an infliximab product administered
                  intravenously
                </option>
                <option value="1">
                  Moderately to severely active Crohn’s disease following
                  treatment with an infliximab product administered
                  intravenously
                </option>
              </Form.Select>
            </Form.Group>
          </>
        )}
        <Form.Group className="mb-4" controlId="Q_INSURANCE_TYPE">
          <Form.Label>{insuranceTypeLabel}</Form.Label>
          <Form.Select
            name="Q_INSURANCE_TYPE"
            id="Q_INSURANCE_TYPE"
            className={insuranceType && "error"}
            {...register("Q_INSURANCE_TYPE", {
              onChange: (e) => {
                InsuranceTypeHandler(e);
              },
            })}
          >
            <option selected disabled>
              Choose
            </option>
            <option value="1">
              Any government, state, or federally funded prescription benefit
              program. This includes Medicare, Medicaid, Medigap, VA, DoD, and
              TRICARE
            </option>
            <option value="2">Commercially insured (private insurance)</option>
            <option value="3">Does not have drug coverage - paying cash</option>
          </Form.Select>
        </Form.Group>
        {!isPaysign ? (
          <>
            <Form.Group className="mb-4" controlId="Q_COUNTRY">
              <Form.Label>{residencyLabel}</Form.Label>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  required
                  inline
                  label="Yes"
                  value="Y"
                  name="Q_COUNTRY"
                  type={"radio"}
                  id={`Q_COUNTRY_Y`}
                  {...register("Q_COUNTRY", {
                    onChange: (e) => {
                      QountryHandler(e);
                    },
                  })}
                />
                <Form.Check
                  inline
                  label="No"
                  value="N"
                  name="Q_COUNTRY"
                  className={qountry && "error"}
                  type={"radio"}
                  id={`Q_COUNTRY_N`}
                  {...register("Q_COUNTRY", {
                    onChange: (e) => {
                      QountryHandler(e);
                    },
                  })}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-4" controlId="Q_AGE_18">
              <Form.Label>{ageLabel}</Form.Label>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  required
                  inline
                  label="Yes"
                  value="Y"
                  name="Q_AGE_18"
                  type={"radio"}
                  id={`Q_AGE_18_Y`}
                  {...register("Q_AGE_18", {
                    onChange: (e) => {
                      age18Handler(e);
                    },
                  })}
                />
                <Form.Check
                  inline
                  label="No"
                  value="N"
                  name="Q_AGE_18"
                  type={"radio"}
                  className={ageeighteen && "error"}
                  id={`Q_AGE_18_N`}
                  {...register("Q_AGE_18", {
                    onChange: (e) => {
                      age18Handler(e);
                    },
                  })}
                />
              </div>
            </Form.Group>
            <Form.Group
              className="mb-4"
              controlId="Q_HIPAA_PATIENT_RELATIONSHIP"
            >
              <Form.Label>{hippaRelationshipLabel}</Form.Label>
              <Form.Select
                className={errors.Q_HIPAA_PATIENT_RELATIONSHIP && "error"}
                name="Q_HIPAA_PATIENT_RELATIONSHIP"
                id="Q_HIPAA_PATIENT_RELATIONSHIP"
                {...register("Q_HIPAA_PATIENT_RELATIONSHIP", {
                  required: true,
                })}
              >
                <option selected disabled value="">
                  Choose
                </option>
                <option value="1">Patient</option>
                <option value="2">Caregiver</option>
                <option value="3">Advocate</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-4" controlId="Q_READ_TERMS">
              <Form.Label>
                I confirm that I have read, consent, and agree to the{" "}
                <a
                  href="javascript:void(0)"
                  onClick={() => setExitPrivacy(true)}
                >
                  User Privacy Policy{" "}
                </a>{" "}
                and the{" "}
                <a href="javascript:void(0)" onClick={() => setExitTerms(true)}>
                  Terms and Conditions
                </a>
                , and that I am of legal age.
              </Form.Label>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  inline
                  label="Yes"
                  value="Y"
                  name="Q_READ_TERMS"
                  type={"radio"}
                  id={`readterms-yes`}
                  {...register("Q_READ_TERMS", {
                    required: true,
                    onChange: (e) => {
                      QREADTERMS(e);
                    },
                  })}
                />
                <Form.Check
                  inline
                  label="No"
                  value="N"
                  name="Q_READ_TERMS"
                  type={"radio"}
                  className={qreadterms && "error"}
                  id={`readterms-no`}
                  {...register("Q_READ_TERMS", {
                    required: true,
                    onChange: (e) => {
                      QREADTERMS(e);
                    },
                  })}
                />
              </div>
            </Form.Group>
            <Form.Group
              className="mb-4 eligibility"
              controlId="Q_HIPPA_CONSENT"
            >
              <Form.Label>
                By signing this form, you certify that the patient gives their
                permission for their physicians, pharmacies, laboratories, and
                other healthcare providers (“Healthcare Providers”) and their
                health insurers to share their individually identifiable health
                information with Celltrion USA, Inc., the Celltrion Patient
                Assistance Foundation, Celltrion USA affiliates and its vendors
                (collectively, “Celltrion USA”). The patient understands that
                their individually identifiable health information may include
                their full name, address, date of birth, demographic
                information, financial information, insurance information and
                information related to medical condition, treatment, care
                management, medication history, and prescriptions (collectively,
                “Health Information”), whether in written or verbal form,
                including portions of their medical record. The patient’s Health
                Information will be shared with Celltrion USA so that Celltrion
                USA may provide them with various support and information to
                help them access a Celltrion USA medicine, which may include the
                following, depending on the program (collectively, “Patient
                Support Activities”).
              </Form.Label>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  inline
                  label="Yes"
                  value="Y"
                  name="Q_HIPPA_CONSENT"
                  type={"radio"}
                  id={`signsin-yes`}
                  {...register("Q_HIPPA_CONSENT", {
                    required: true,
                    onChange: (e) => {
                      QHIPPACONSENT(e);
                    },
                  })}
                />
                <Form.Check
                  inline
                  label="No"
                  value="N"
                  name="Q_HIPPA_CONSENT"
                  type={"radio"}
                  className={qhippaconsent && "error"}
                  id={`signsin-no`}
                  {...register("Q_HIPPA_CONSENT", {
                    required: true,
                    onChange: (e) => {
                      QHIPPACONSENT(e);
                    },
                  })}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-4" controlId="Q_PAT_CONSENT">
              <Form.Label>
                {(isZymfentra ||
                  (category === "adalimumab" && roleName !== "patient")) && (
                  <>
                    The patient understands that the personal information
                    provided and information pertaining to using the Celltrion
                    CARES<sup className="reg">&reg;</sup> Co-pay Assistance
                    Program will be shared with Celltrion USA, its third-party
                    partners and entities. The patient also authorizes Celltrion
                    USA, its partners and entities to communicate with him/her
                    about products, health conditions, co-pay and financial
                    assistance. The patient agrees to be contacted by mail,
                    email, and at the phone number provided to leave voice
                    messages, and interactive voice recordings. The patient may
                    opt out of individual communications of the program entirely
                    at any time by calling 1-877-812-6662.
                    Celltrion USA and companies providing services to Celltrion
                    USA will not sell or rent personally identifiable
                    information, as described in the Privacy Policy, which can
                    be viewed by visiting CelltrionCares.com.
                  </>
                )}
                {(category === "vegzelma") && (
                  <>
                    The patient understands that the personal information
                    provided and information pertaining to using the Celltrion
                    CARES<sup className="reg">&reg;</sup> Co-pay Assistance
                    Program will be shared with Celltrion USA, its third-party
                    partners and entities. Does the patient also authorize
                    Celltrion USA, its partners and entities to communicate with
                    him/her about products, health conditions, co-pay and
                    financial assistance. The patient agrees to be contacted by
                    mail, email, and at the phone number provided to leave voice
                    messages, and interactive voice recordings. The patient may
                    opt out of individual communications of the program entirely
                    at any time by calling 1-877-812-6662, or by
                    clicking on the "unsubscribe" link. Celltrion USA and
                    companies providing services to Celltrion USA will not sell
                    or rent personally identifiable information, as described in
                    the Privacy Policy, which can be viewed by visiting{" "}
                    <a
                      target="_blank"
                      href="https://www.celltrionconnect.com"
                      rel="noreferrer"
                    >
                      www.celltrionconnect.com
                    </a>
                    .
                  </>
                )}
                {category === "adalimumab" && roleName === "patient" && (
                  <>
                    Do you understand that the personal information provided and
                    information pertaining to using the Celltrion CARES
                    <sup className="reg">&reg;</sup> Co-pay Assistance Program
                    will be shared with Celltrion, its third-party partners and
                    entities. Do you also authorize Celltrion, its partners and
                    entities to communicate with him/her about products, health
                    conditions, co-pay, and financial assistance. The patient
                    agrees to be contacted by mail, email, and at the phone
                    number provided to leave voice messages, and interactive
                    voice recordings. The patient may opt out of individual
                    communications of the program entirely at any time by
                    calling 1-877-812-6662, or by clicking on
                    the "unsubscribe" link. Celltrion and companies providing
                    services to Celltrion will not sell or rent personally
                    identifiable information, as described in the Privacy
                    Policy, which can be viewed by visiting{" "}
                    <a
                      target="_blank"
                      href="https://www.celltrionconnect.com"
                      rel="noreferrer"
                    >
                      www.celltrionconnect.com
                    </a>
                    .
                  </>
                )}
              </Form.Label>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  required
                  inline
                  label="Agree"
                  value="Y"
                  name="Q_PAT_CONSENT"
                  type={"radio"}
                  id={`patientn-yes`}
                  {...register("Q_PAT_CONSENT", {
                    required: true,
                    onChange: (e) => {
                      PATConsent(e);
                    },
                  })}
                />
                <Form.Check
                  inline
                  label="Disagree"
                  value="N"
                  name="Q_PAT_CONSENT"
                  type={"radio"}
                  className={patconsent && "error"}
                  id={`patientn-no`}
                  {...register("Q_PAT_CONSENT", {
                    required: true,
                    onChange: (e) => {
                      PATConsent(e);
                    },
                  })}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-4" controlId="Q_TEXT_OPT_IN">
              <Form.Label>
                {category === "vegzelma" && (
                  <>
                    As part of the Celltrion CARES
                    <sup className="reg">&reg;</sup> Co-pay Assistance Program,
                    the patient understands and agrees to receive autodialed
                    text messages from Celltrion USA, any companies working with
                    Celltrion USA and McKesson entities that support this
                    program, which may include refill reminders and other
                    offers. The patient understands he/she is not required to
                    agree to receive text messages as a condition of this
                    savings offer, that message and data rates may apply, and
                    that these text messages will reoccur monthly. The patient
                    may text 'STOP' to opt out at any time. For help at any
                    time, text 'HELP'. For additional support call
                    1-877-812-6662. Participating Carriers: All
                    U.S. Based Carriers. Messages may be delayed or undelivered
                    for various factors. McKesson, carriers (including, but not
                    limited to, T-Mobile) and any service providers utilized by
                    McKesson to send messages are not liable for delayed or
                    undelivered messages.
                  </>
                )}
                {category === "zymfentra" && (
                  <>
                    As part of the Celltrion CARES
                    <sup className="reg">&reg;</sup> Co-pay Assistance, the
                    patient understands and agrees to receive autodialed text
                    messages from Celltrion USA, any companies working with
                    Celltrion USA and Paysign entities that support this
                    program, which may include refill reminders and other
                    offers. The patient understands he/she is not required to
                    agree to receive text messages as a condition of this
                    savings offer, that message and data rates may apply, and
                    that these text messages will reoccur monthly. The patient
                    may text 'STOP' to opt out at any time. For help at any
                    time, text 'HELP'. For additional support call
                    1-877-812-6662. Participating Carriers: All
                    U.S. Based Carriers. Messages may be delayed or undelivered
                    for various factors. Carriers and any service providers
                    utilized to send messages are not liable for delayed or
                    undelivered messages.
                  </>
                )}

                {category === "adalimumab" && (
                  <>
                    As part of the Celltrion CARES Co-pay Assistance Program,
                    the patient understands and agrees to receive autodialed
                    text messages from Celltrion, any companies working with
                    Celltrion, and Paysign entities that support this program,
                    which may include refill reminders and other offers. The
                    patient understands he/she is not required to agree to
                    receive text messages as a condition of this savings offer,
                    that message and data rates may apply, and that these text
                    messages will reoccur monthly. The patient may text “STOP”
                    to opt out at any time. For help at any time, text “HELP.”
                    For additional support, call 1-877-812-6662.
                    Participating Carriers: All US-Based Carriers. Messages may
                    be delayed or undelivered for various factors. Carriers and
                    any service providers utilized to send messages are not
                    liable for delayed or undelivered messages.
                  </>
                )}
              </Form.Label>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  required
                  inline
                  label="Agree"
                  value="Y"
                  name="Q_TEXT_OPT_IN"
                  type={"radio"}
                  id={`cares-yes`}
                  {...register("Q_TEXT_OPT_IN", {
                    required: true,
                  })}
                />
                <Form.Check
                  inline
                  label="Disagree"
                  value="N"
                  name="Q_TEXT_OPT_IN"
                  type={"radio"}
                  className={textOptIn}
                  id={`cares-no`}
                  {...register("Q_TEXT_OPT_IN", {
                    required: true,
                  })}
                />
              </div>
            </Form.Group>
          </>
        ) : (
          <>
            <Form.Group
              className="mb-4"
              controlId="Q_HIPAA_PATIENT_RELATIONSHIP"
            >
              <Form.Label>{hippaRelationshipLabel}</Form.Label>
              <Form.Select
                name="Q_HIPAA_PATIENT_RELATIONSHIP"
                id="Q_HIPAA_PATIENT_RELATIONSHIP"
                className={errors.Q_HIPAA_PATIENT_RELATIONSHIP && "error"}
                {...register("Q_HIPAA_PATIENT_RELATIONSHIP")}
              >
                <option selected disabled>
                  Choose
                </option>
                <option value="1">Patient</option>
                <option value="2">Caregiver</option>
                <option value="3">Advocate</option>
                <option value="4">Healthcare Provider</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-4" controlId="Q_COUNTRY">
              <Form.Label>
                Is the patient a resident of the United States or the
                Commonwealth of Puerto Rico?
              </Form.Label>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  required
                  inline
                  label="Yes"
                  value="Y"
                  name="Q_COUNTRY"
                  type={"radio"}
                  id={`Q_COUNTRY_Y`}
                  {...register("Q_COUNTRY", {
                    onChange: (e) => {
                      QountryHandler(e);
                    },
                  })}
                />
                <Form.Check
                  inline
                  label="No"
                  value="N"
                  name="Q_COUNTRY"
                  className={qountry && "error"}
                  type={"radio"}
                  id={`Q_COUNTRY_N`}
                  {...register("Q_COUNTRY", {
                    onChange: (e) => {
                      QountryHandler(e);
                    },
                  })}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-4" controlId="Q_AGE_18">
              <Form.Label>
                Is the patient, caregiver, or legal guardian of the patient 18
                years of age or older?
              </Form.Label>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  required
                  inline
                  label="Yes"
                  value="Y"
                  name="Q_AGE_18"
                  type={"radio"}
                  id={`Q_AGE_18_Y`}
                  {...register("Q_AGE_18", {
                    onChange: (e) => {
                      age18Handler(e);
                    },
                  })}
                />
                <Form.Check
                  inline
                  label="No"
                  value="N"
                  name="Q_AGE_18"
                  className={ageeighteen && "error"}
                  type={"radio"}
                  id={`Q_AGE_18_N`}
                  {...register("Q_AGE_18", {
                    onChange: (e) => {
                      age18Handler(e);
                    },
                  })}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-4" controlId="Q_READ_TERMS">
              <div>
                <hr></hr>
              </div>
              <Form.Label>
                I confirm that I have read, consent, and agree to the User{" "}
                <a
                  href="javascript:void(0)"
                  onClick={() => setExitPrivacy(true)}
                  style={{ color: productColor, textDecoration: "underline" }}
                >
                  Privacy Policy
                </a>{" "}
                and the{" "}
                <a
                  href="#"
                  onClick={() => setTsAndCsShow(true)}
                  style={{ color: productColor, textDecoration: "underline" }}
                >
                  Terms and Conditions
                </a>{" "}
                and that I am of legal age.
              </Form.Label>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  required
                  inline
                  label="Agree"
                  value="Y"
                  name="Q_READ_TERMS"
                  type={"radio"}
                  id={`Q_READ_TERMS_Y`}
                  {...register("Q_READ_TERMS", {
                    required: true,
                    onChange: (e) => {
                      QREADTERMS(e);
                    },
                  })}
                />
                <Form.Check
                  inline
                  label="Disagree"
                  value="N"
                  name="Q_READ_TERMS"
                  className={qreadterms && "error"}
                  type={"radio"}
                  id={`Q_READ_TERMS_N`}
                  {...register("Q_READ_TERMS", {
                    required: true,
                    onChange: (e) => {
                      QREADTERMS(e);
                    },
                  })}
                />
              </div>
            </Form.Group>
            <Form.Group
              className="mb-4 eligibility"
              controlId="Q_HIPPA_CONSENT"
            >
              <div style={{ lineHeight: "1.5" }}>
                <div style={{ paddingBottom: "20px" }}>
                  By signing this form, the patient gives their permission for
                  their physicians, pharmacies, laboratories, and other
                  healthcare providers (“Healthcare Providers”) and their health
                  insurers to share their individually identifiable health
                  information with Celltrion, the Celltrion Patient Assistance
                  Foundation, and Celltrion affiliates and its vendors
                  (collectively, “Celltrion”).
                </div>
                <div style={{ paddingBottom: "20px" }}>
                  The patient understands that their individually identifiable
                  health information may include their full name, address, date
                  of birth, demographic information, financial information,
                  insurance information, and information related to their
                  medical condition, treatment, care management, medication
                  history, and prescriptions (collectively, “Health
                  Information”), whether in written or verbal form, including
                  portions of their medical record.
                </div>
                <div style={{ paddingBottom: "5px" }}>
                  The patient’s Health Information will be shared with Celltrion
                  so that Celltrion may provide them with various support and
                  information to help them access a Celltrion medicine, which
                  may include the following, depending on the program
                  (collectively, “Patient Support Activities”):
                </div>
                <div style={{ paddingBottom: "20px", marginLeft: "30px" }}>
                  <ul style={{ listStyle: "disc" }}>
                    <li>Processing this application</li>
                    <li>
                      Verifying the information provided in this application
                    </li>
                    <li>
                      Providing benefit investigation/verification and
                      reimbursement support, including:
                    </li>
                    <ul style={{ listStyle: "disc", marginLeft: "30px" }}>
                      <li>
                        Assisting with identification of prior authorization
                        requirements
                      </li>
                      <li>
                        Assisting with the identification of requirements of
                        their insurer for appeal of a denied claim
                      </li>
                    </ul>
                    <li>
                      Determining their eligibility for and helping them access
                      co-pay support or free drug programs
                    </li>
                    <li>
                      Communicating with their Healthcare Providers about
                      Celltrion medicine and Patient Support Activities
                    </li>
                    <li>
                      Coordinating the dispensing and delivery of medication
                    </li>
                    <li>
                      Providing them with financial assistance resources and
                      information if they are eligible
                    </li>
                    <li>
                      Providing them with disease management and other
                      educational materials, as well as information about
                      Celltrion’s products, services, and programs, may include
                      sending them surveys about their experience with Celltrion
                      products, services, and programs
                    </li>
                  </ul>
                </div>
              </div>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  inline
                  label="Yes"
                  value="Y"
                  name="Q_HIPPA_CONSENT"
                  type={"radio"}
                  id={`signsin-yes`}
                  {...register("Q_HIPPA_CONSENT", {
                    required: true,
                    onChange: (e) => {
                      QHIPPACONSENT(e);
                    },
                  })}
                />
                <Form.Check
                  inline
                  label="No"
                  value="N"
                  name="Q_HIPPA_CONSENT"
                  type={"radio"}
                  className={qhippaconsent && "error"}
                  id={`signsin-no`}
                  {...register("Q_HIPPA_CONSENT", {
                    required: true,
                    onChange: (e) => {
                      QHIPPACONSENT(e);
                    },
                  })}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-4" controlId="Q_PAT_CONSENT">
              <Form.Label>
                The patient understands that the personal information provided
                and information pertaining to using the Celltrion CARES
                <sup className="reg">&reg;</sup> Co-pay Assistance Program will
                be shared with Celltrion, its third-party partners, and
                entities. The patient also authorizes Celltrion, its partners,
                and entities to communicate with him/her about products, health
                conditions, and co-pay and financial assistance. The patient
                agrees to be contacted by mail, email, and at the phone number
                provided to leave voice messages and interactive voice
                recordings. The patient may opt out of individual communications
                of the program entirely at any time by calling 1-877-812-6662. Celltrion and companies providing services to
                Celltrion will not sell or rent personally identifiable
                information, as described in the Privacy Policy, which can be
                viewed by visiting CelltrionCares.com.
              </Form.Label>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  required
                  inline
                  label="Yes"
                  value="Y"
                  name="Q_PAT_CONSENT"
                  type={"radio"}
                  id={`Q_PAT_CONSENT_Y`}
                  {...register("Q_PAT_CONSENT", {
                    required: true,
                    onChange: (e) => {
                      PATConsent(e);
                    },
                  })}
                />
                <Form.Check
                  inline
                  label="No"
                  value="N"
                  name="Q_PAT_CONSENT"
                  className={patconsent && "error"}
                  type={"radio"}
                  id={`Q_PAT_CONSENT_N`}
                  {...register("Q_PAT_CONSENT", {
                    required: true,
                    onChange: (e) => {
                      PATConsent(e);
                    },
                  })}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-4" controlId="Q_TEXT_OPT_IN">
              <Form.Label>
                As part of the Celltrion CARES Co-pay Assistance Program, the
                patient understands and agrees to receive autodialed text
                messages from Celltrion, any companies working with Celltrion,
                and {isPaysign ? "Paysign" : "McKesson"} entities that support
                this program, which may include refill reminders and other
                offers. The patient understands he/she is not required to agree
                to receive text messages as a condition of this savings offer,
                that message and data rates may apply, and that these text
                messages will reoccur monthly. The patient may text “STOP” to
                opt out at any time. For help at any time, text “HELP.” For
                additional support, call 1-877-812-6662.
                Participating Carriers: All US-Based Carriers. Messages may be
                delayed or undelivered for various factors. Carriers and any
                service providers utilized to send messages are not liable for
                delayed or undelivered messages.
              </Form.Label>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  required
                  inline
                  label="Agree"
                  value="Y"
                  name="Q_TEXT_OPT_IN"
                  type={"radio"}
                  id={`cares-yes`}
                  {...register("Q_TEXT_OPT_IN", {
                    required: true,
                  })}
                />
                <Form.Check
                  inline
                  label="Disagree"
                  value="N"
                  name="Q_TEXT_OPT_IN"
                  type={"radio"}
                  className={textOptIn}
                  id={`cares-no`}
                  {...register("Q_TEXT_OPT_IN", {
                    required: true,
                  })}
                />
              </div>
            </Form.Group>
          </>
        )}
      </div>
      <div className="form-buttons">
        <div className="s2-button">
          {/* Step 1 has no earlier step, so Back returns to the product
              entry page - which is exactly what handleCancel does. */}
          <Button className={`${productName}-backbtn`} onClick={handleCancel}>
            Back
          </Button>
          <Button
            className={`${productName}-nextbtn`}
            onClick={() => {
              nextStep();
            }}
            disabled={
              indication ||
              insuranceType ||
              qountry ||
              ageeighteen ||
              patconsent ||
              textOptIn ||
              qhippaconsent ||
              qreadterms
            }
          >
            Next
          </Button>
        </div>
        <Button
          onClick={handleCancel}
          variant="light"
          className={`theme-button ${productName}-theme-button-text`}
        >
          Cancel
        </Button>
      </div>
      <CelltrionCare
        show={TsAndCsShowShow}
        onHide={() => setTsAndCsShow(false)}
        isVegzelma={false}
        isZymfentra={true}
        isYuflyma={false}
        isAdalimumab={false}
        isSteqeyma={false}
        isAvtozma={false}
      />
    </>
  );
};

export default Eligibility;
